// Huella de contenido: "¿esto sigue diciendo lo mismo?".
//
// Nació en la entrega 1 dentro de evolucionIA (huellaEntrada) para saber si una
// nota cambió mientras la IA la ordenaba. Se sacó a su propio módulo en la
// entrega 2 porque ahora la usan dos consumidores que no deben acoplarse: el
// reparto (vigencia de una solicitud) y las VERSIONES de una entrada (¿esta
// edición cambió algo de verdad?).
//
// LA REGLA QUE ESTE ARCHIVO EXISTE PARA PROTEGER: la igualdad de contenido es
// independiente del ORDEN DE LAS CLAVES. `JSON.stringify` serializa en orden de
// inserción, así que guardar {a,b} y volver a guardar {b,a} producía huellas
// distintas y descartaba un reparto sano (riesgo anotado al cerrar la entrega
// 1). Acá las claves de todo objeto se ordenan antes de serializar.
//
// No es hash criptográfico ni contador: dice "igual" o "distinto", jamás
// "cuántas veces cambió" ni en qué orden. Para eso están las versiones.

// Copia con las claves de cada objeto ordenadas, en profundidad. Los arrays
// CONSERVAN su orden (en un array el orden es dato: la lista de hallazgos de un
// sistema no significa lo mismo al revés).
export function canonicalizar(valor) {
  if (Array.isArray(valor)) return valor.map(canonicalizar);
  if (valor && typeof valor === 'object') {
    const out = {};
    for (const k of Object.keys(valor).sort()) out[k] = canonicalizar(valor[k]);
    return out;
  }
  return valor;
}

export function huellaDe(valor) {
  return JSON.stringify(canonicalizar(valor));
}
